<div class="text-center mt-4">
  <mat-icon aria-hidden="false" aria-label="Whoops icon">fmd_bad</mat-icon>
</div>
<h1 class="text-center" mat-dialog-title>{{data.title || 'Whoops'}}</h1>
<div mat-dialog-content *ngIf="{ hasErrorMessages: (data.errorMessages || []).length > 0 } as state">
  <div class="text-center">There were errors with the provided input.</div>
  <mat-divider *ngIf="state.hasErrorMessages" class="mt-4 mb-4"></mat-divider>
  <ul *ngIf="state.hasErrorMessages">
    <li *ngFor="let errorMessage of data.errorMessages">{{errorMessage}}</li>
  </ul>
  <mat-divider *ngIf="state.hasErrorMessages" class="mt-4 mb-4"></mat-divider>
</div>
<div mat-dialog-actions class="justify-end">
  <button mat-button [mat-dialog-close]="true">OK</button>
</div>
